import { isRunningInExpoGo } from 'expo';
import HelperPlatform from 'utils/helper-platform';

// Avoid evaluating expo-notifications in Android Expo Go: importing it can
// report unsupported push functionality before any registration is attempted.
const Notifications = HelperPlatform.isAndroid() && isRunningInExpoGo()
	? null
	: require( 'expo-notifications' );

export default Notifications;
